import { Link } from 'react-router-dom';

interface Crumb {
  label: string;
  to?: string;
}

interface BreadcrumbsProps {
  items: Crumb[];
}

export default function Breadcrumbs({ items }: BreadcrumbsProps) {
  return (
    <nav aria-label="面包屑导航" className="flex flex-wrap items-center gap-2 font-label text-xs text-foreground-500">
      <Link to="/" className="transition-colors hover:text-primary-600">
        首页
      </Link>
      {items.map((item) => (
        <span key={item.label} className="flex items-center gap-2">
          <i className="ri-arrow-right-s-line text-sm text-foreground-400" />
          {item.to ? (
            <Link to={item.to} className="transition-colors hover:text-primary-600">
              {item.label}
            </Link>
          ) : (
            <span className="text-foreground-800">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}